import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL_V3, STORE_BASE_PATH } from '../../common/constants';
import { prepareHeaders } from '../tokenHandling/prepareHeaders';

export const baseApiV3 = createApi({
    reducerPath: `${STORE_BASE_PATH}facadeApiV3`,
    baseQuery: fetchBaseQuery({ baseUrl: BASE_URL_V3, prepareHeaders }),
    endpoints: builder => ({}),
});
